export const LOGIN_API = "api/User/UserLogin";
export const GET_FITTERS_API = "api/User/GetAllFitters";
export const GET_USERS_API = "api/User/GetUsers";
export const UPDATE_USER_API = "api/User/UpdateUser";
export const GET_DEPOTS_API = "api/User/GetDepots";
export const GET_HASHED_PASSWORD_API = "api/User/GetHashedPassword";
export const SAVE_FITTER_DETAILS_API = "api/User/SaveFitterDetails";
export const DOWNLOAD_SUBMITTED_WORKSHEETS = "api/User/DownloadSubmittedWorksheet";
export const GENERATE_QRCODE = "api/User/GenerateQRCode";
export const UPDATE_SUBMISSION_STATUS = "api/User/UpdateSubmissionStatus";
export const GET_SUBMISSION_STATUS = "api/User/GetSubmissionStatus";
export const GET_WORKSHEETS_BETWEEN_DATES = "api/User/GetCallOffWorkSheetsBetweenDates";
export const GET_SITE_CONTACTS_BY_SYSTEMID = "api/User/GetSiteContactsBySystemId";
export const ADD_SITE_CONTACTS = "api/User/AddSiteContacts";
export const GET_FITTERS_FROM_PLANNER_NOT_IN_FITAPP = "api/User/GetFittersFromPlannerNotInFitapp";
export const UPLOAD_CUSTOMER_PAYMENT_FORM = "api/User/UploadCustomerPaymentForm";

export const GET_UNSUBMITTED_WORKSHEETS_BETWEEN_DATES = "api/UploadPaperwork/GetUnsubmittedWorksheetsBetweenDates";
export const UPLOAD_PAPERWORK = "api/Uploadpaperwork/UploadPaperwork";

export const GET_MEASURE_REVISITS = "api/Reports/GetMeasureRevisits";
export const GET_QUERY_INSTALLS = "api/Reports/GetQueryInstalls";
export const GET_UNSUBMITTED_WORKSHEETS = "api/Reports/GetProcessedUnsubmittedWorksheetsBetweenDates";
export const GET_MATERIAL_MANUFACTURER_REPORT = "api/Reports/GetMaterialManufacturerBetweenDates";
export const GET_MEASURES_WITH_PAYMENT_CARD_REQUIRED_STATUS = "api/Reports/GetMeasuresWithPaymentCardRequiredStatus";
export const GET_JOBS_FOR_INVOICING = "api/Reports/GetJobsForInvoicing";
export const DOWNLOAD_WORKCARD_DETAILS_BY_MEASUREIDs = "api/Reports/DownloadWorkcardDetailsByMeasureIds";
export const DOWNLOAD_WORKCARD_DETAILS_WITH_ALL_IMAGES_BY_MEASUREIDs = "api/Reports/DownloadWorkcardDetailsWithAllImagesByMeasureIds";
export const GET_REJECTED_BY_ACCOUNTS = "api/Reports/GetRejectedByAccounts";
export const FITTER_SIGNIN_REPORT = "api/Reports/GetFitterSignInData";

export const GET_PENDING_WAGES = "api/Wages/GetPendingWages";
export const PROCESS_WAGES = "api/Wages/ProcessWages";
export const GET_COMPLETE_WAGES = "api/Wages/GetCompleteWages";
export const GET_WAGES_FOR_MEASURE = "api/Wages/GetWagesForMeasure";
export const CHECK_IF_WAGES_PROCESSED = "api/Wages/CheckIfWagesProcessed";

export const GET_ECO_JOBS_BETWEEN_DATES = "api/Eco/GetEcoJobsBetweenDates";
export const DOWNLOAD_RETRO_DOC = "api/Eco/DownloadEcoWorkcardDetailsByMeasureId";

export const GET_MEASURESCOUNT_BY_SITE = "api/Invoicing/GetMeasuresCountBySite";
export const GET_INVOICING_MEASURES_FOR_SITE = "api/Invoicing/GetInvoicingMeasuresForSite";
export const GET_REJECTED_INVOICE_MEASURESCOUNT_BY_SITE = "api/Invoicing/GetRejectedInvoiceMeasuresCountBySite";
export const GET_REJECTED_INVOICING_MEASURES_FOR_SITE = "api/Invoicing/GetRejectedInvoicingMeasuresForSite";
export const GET_PROCESSED_PAYAPP_MEASURESCOUNT_BY_SITE = "api/Invoicing/GetProcessedPayappMeasuresCountBySite";
export const GET_PROCESSED_PAYAPP_MEASURES_FOR_SITE = "api/Invoicing/GetProcessedPayappMeasuresForSite";
export const GET_INVOICED_PAYAPP_MEASURESCOUNT_BY_SITE = "api/Invoicing/GetInvoicedPayappMeasuresCountBySite";
export const GET_INVOICED_PAYAPP_MEASURES_FOR_SITE = "api/Invoicing/GetInvoicedPayappMeasuresForSite";
export const RETURN_ACCOUNTS_TO_BRANCH = "api/Invoicing/ReturnAccountsToBranch";
export const APPROVE_FINANCE = "api/Invoicing/ApproveFinance";
export const RESEND_ACCOUNTS_FOR_REVIEW = "api/Invoicing/ResendAccountsForReview";
export const PROCESS_PAY_APP = "api/Invoicing/ProcessPayApp";
export const GET_TAX_CODES = "api/Invoicing/GetTaxCodes";
export const SEND_INVOICE = "api/Invoicing/SendInvoice";
export const DOWNLOAD_INVOICE_WITH_DOWNLOAD_OPTIONS = "api/Invoicing/DownloadInvoiceWithDownloadOptions";
export const EXPORT_SAGE_BATCH_PAYAPPS = "api/Invoicing/ExportSageBatchPayapps";
export const GET_SAGE_EXPORT_BATCH_DATA_BETWEEN_DATES = "api/Invoicing/GetSageExportBatchDataBetweenDates";
export const DOWNLOAD_PENDING_INVOICE_WORKCARD_DETAILS_BY_SYSTEMID = "api/Invoicing/DownloadPendingInvoiceWorkcardDetailsBySystemId";

export const SERVICE_LOCATION = "https://eeg-maxdashboardapi.azurewebsites.net/"; //"https://localhost:7283/";   "https://eeg-maxdashboardapi.azurewebsites.net/";